import { useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useSupervisor } from "../../../contexts/SupervisorContext";

export const useSupervisorDetail = () => {
  const { supervisorId } = useParams<{ supervisorId: string }>();
  const { selectedSupervisor, setSelectedSupervisor, loading, error } = useSupervisor();

  // Callback for setting selected supervisor
  const handleSetSelectedSupervisor = useCallback((id: string) => {
    setSelectedSupervisor(id);
  }, [setSelectedSupervisor]);

  useEffect(() => {
    if (supervisorId) {
      handleSetSelectedSupervisor(supervisorId);
    }
  }, [supervisorId, handleSetSelectedSupervisor]);

  return {
    selectedSupervisor,
    loading,
    error,
  };
}; 